import { useQuery } from "@apollo/client";
import UserShowQuery from "../graphql/queries/UserShowQuery.graphql";
import UserEditQuery from "../graphql/queries/UserEditQuery.graphql";

/**
 * Хук для загрузки одного пользователя (для просмотра)
 */
export function useUserShowQuery(id: string | null, skip = false) {
  return useQuery(UserShowQuery, {
    variables: { id },
    skip: skip || !id,
  });
}

/**
 * Хук для загрузки пользователя для редактирования
 */
export function useUserEditQuery(id: string | null, skip = false) {
  return useQuery(UserEditQuery, {
    variables: { id },
    skip: skip || !id,
  });
}
